import { render, staticRenderFns } from "./ChangeAppLanguage.vue?vue&type=template&id=568c3296"
import script from "./ChangeAppLanguage.vue?vue&type=script&lang=js"
export * from "./ChangeAppLanguage.vue?vue&type=script&lang=js"
import style0 from "./ChangeAppLanguage.vue?vue&type=style&index=0&id=568c3296&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports